"use strict";
// tslint:disable
/**
 * platform-api-media-service
 * Media Services API is used to manage calls on both the cloud call control and premise PBX systems.  All resources are secured by an API token passed in the Authorization header.  Collection requests support basic OData syntax.  To manipulate paged data utilize the $skip & $top query string syntax. For example:  * Get first 5 results: `/2017-09-01/calls?$top=5`  * Skip 5 then get next 5 results: `/2017-09-01/calls$skip=5&$top=5`  Basic filter syntax is supported for targeted queries.  For example:  * Get inbound calls: `/2017-09-01/calls?$filter=\"direction eq 'inbound'\"`
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * MediaService
 * @class
 */
class MediaService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-media',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Media' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Make an outbound call from your account registered endpoint to a destination.  Depending on the type of token being used the behaviour may be different. User tokens are based on your endpoints registered to you and make call will result in a call being made from or to one of your specified devices. You must have the from devices registered to you in order to make this call.  Application tokens on the other hand will make a call on behalf of the media controllable gateway in the cloud. You use this method to build IVR / Voice mail applications when machine to human interactions are desired.    make call user token. from is implied by sipaddress in user token  `{ \"to\": \"+16134444444\" }`  make call with recording  `{ \"to\": \"+16134444444\", \"record\": true }`  make call from personal desktop phone  `{ \"from\": \"1000\", \"to\": \"+16134444444\" }`  make call to specify action on answer  `{ \"from\": \"1000\", \"to\": \"+16134444444\", \"executeOnAnswer\": \"bridge\", \"associatedCallId\": \"c1234\"  }`  Async make call with callback as application token Returns accepted on response  `{ \"from\": \"+16135990045\", \"fromName\": \"Sales Department\", \"to\": \"+16134444444\", \"notificationUrl\": \"http://server/notify\"}`    Async make call with additional caller info and callback as application token Returns accepted on response  `{ \"from\": \"+16135990045\", \"fromName\": \"Sales Department\", \"to\": \"+16134444444\", \"additionalCallerName\": \"ring group\", \"additionalCallerNumber\": \"123456\", \"additionalCallerType\": \"groupCall\", \"notificationUrl\": \"http://server/notify\" }`, currectly \"groupCall\" type supported for \"additionalCallerType\"
    * @summary Make a Call
    * @param {CreateCallRequest} body
    * @throws {RequiredError}
    */
    createCall(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createCall.');
        }
        const path = `/calls`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the current state of an active call.
    * @summary Get a Call State
    * @param {string} callId callId
    * @throws {RequiredError}
    */
    getCall(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling getCall.');
        }
        const path = `/calls/{callId}`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all live calls for this account on both premise and cloud. Basic paging and filtering support is available. See above. Historical queries coming soon.
    * @summary Get Calls
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getCalls(params) {
        const path = `/calls`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Manipulate current call state by issuing an appropriate action to take on the call for the provided ID. Some actions require additional arguments.  Examples  To answer or clear a call  `{ \"action\": \"answer\"}`  `{ \"action\": \"end\"}`  To toggle the holding state of the call  `{ \"action\": \"hold\", \"options\": { \"destination\": \"1000\" } }`  `{ \"action\": \"retrieve\" \"options\": { \"destination\": \"1000\" } }`  To transfer a call  `{ \"action\": \"transfer\", \"options\": { \"destination\": \"+15555555\" } }`  `{ \"action\": \"transfer\", \"options\": { \"destination\": \"+15555555\", \"leg\": \"b\" } }`  `{ \"action\": \"transfer\", \"options\": { \"ringAlgorithm\": \"ringAll\", \"destination\": \"+15555555\" } }`  To send dtmf digits. Tone duration is optional and specified in ms. Default is 2000  `{ \"action\": \"dtmf\", \"options\": { \"tones\": \"1234\", \"duration\": 2000 } }`  To start or stop recording  `{ \"action\": \"record\", \"options\": { \"recording\": true } }`  `{ \"action\": \"bridge\", \"options\": { \"callId\": \"12345\" } }`  To initiate a conference hosted on Connect  `{ \"action\": \"conference\", \"options\": { \"anotherCallId\": \"heldCallId12345\" } }`  To pause a recording  `{ \"action\": \"pauseRecording\" }`  To resume a paused recording  `{ \"action\": \"resumeRecording\" }`  To tag the recording  `{ \"action\": \"tagRecording\", \"options\": \"{ \\\"CustomP100\\\": \\\"Queue Name\\\", \\\"CustomP101\\\": \\\"Queue Disable\\\" }\" }`  To monitor a call. The destination will be the supervisor and will receive the monitor call.  `{ \"action\": \"monitor\", \"options\": { \"destination\": \"1000\" }`  To escalate a monitor call to a whisper call, allowing the supervisor to talk to the specified 'leg' ('a' or 'b'). If 'leg' isn't specified then it defaults to 'b'.  `{ \"action\": \"whisper\", \"options\": { \"leg\": \"b\" }`  To escalate a whisper call to a barge call, allowing all parties to speak  `{ \"action\": \"barge\" }`
    * @summary Run call control command
    * @param {string} callId callId
    * @param {PostCallControlCommand} body
    * @throws {RequiredError}
    */
    runCallControlCommand(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling runCallControlCommand.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling runCallControlCommand.');
        }
        const path = `/calls/{callId}`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Starts a new media stream to an active call. NOTE you can only interface with a call that the cloud call control is in the media path. For calls existing purely on premise PBX systems you must transfer these calls to a media controllable endpoint.  Two speech engines are used for tts. Microsoft Bing and Amazon Polly  Examples  Start media  `{ \"play\": [ { \"resourceUri\": \"welcome.en\" }], \"minCollectedDigits\": 1 }`  Start audio with digit collection and repeat logic  `{ \"play\": [ { \"resourceUri\": \"welcome.en\" }], \"minCollectedDigits\": 4, \"maxCollectedDigits\": 4, \"tries\": 2 }`  Start audio with a chain set of instructions including TTS  `{ \"play\": [ { \"resourceUri\": \"welcome.en\" }, { \"ttsPhrase\": \"This is a message\", \"ttsVoice\": \"en-ca:female\" }], \"minCollectedDigits\": 4, \"maxCollectedDigits\": 4, \"tries\": 2 }`  Start audio continuously  `{ \"play\": [ { \"resourceUri\": \"welcome.en\" }, { \"ttsPhrase\": \"This is a message\", \"ttsVoice\": \"en-ca:female\" }], \"mode\": \"async\", \"loop\": true}`
    * @summary Start media instructions on an active call
    * @param {string} callId callId
    * @param {PostCallMediaRequest} body
    * @throws {RequiredError}
    */
    startMedia(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling startMedia.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling startMedia.');
        }
        const path = `/calls/{callId}/media`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Stop any on-going media streams to all call-legs.
    * @summary Stop Media
    * @param {string} callId callId
    * @throws {RequiredError}
    */
    stopMedia(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling stopMedia.');
        }
        const path = `/calls/{callId}/media`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Terminates an active call for the provided ID.
    * @summary Terminate a Call
    * @param {string} callId callId
    * @throws {RequiredError}
    */
    terminateCall(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling terminateCall.');
        }
        const path = `/calls/{callId}`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves a call record.
    * @summary Get a call record
    * @param {string} callId callId
    * @throws {RequiredError}
    */
    getCallRecord(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling getCallRecord.');
        }
        const path = `/calls/{callId}/records`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves call records. Example - $filter=contains(principal, '76f110ca-f769-4020-95cd-dc75d391d7f1')
    * @summary Get call records
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getCallRecords(params) {
        const path = `/calls/records`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update call record.
    * @summary Update a call record.
    * @param {string} callId callId
    * @param {CallRecordPutRequest} body
    * @throws {RequiredError}
    */
    updateCallRecord(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling updateCallRecord.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCallRecord.');
        }
        const path = `/calls/{callId}/records`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update call records.
    * @summary Update call history records.
    * @param {CallRecordPutRequest} body
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    updateCallRecords(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCallRecords.');
        }
        const path = `/calls/records`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a tag for the call with the provided Id.
    * @summary Create a call tag
    * @param {string} callId Call Identifier
    * @param {CallTagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    createCallTag(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling createCallTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createCallTag.');
        }
        const path = `/calls/{callId}/tags`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the tag for the provided call Id.
    * @summary Delete a tag
    * @param {string} callId Call Identifier
    * @param {string} callTagId ID of the tag
    * @throws {RequiredError}
    */
    deleteCallTag(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling deleteCallTag.');
        }
        // verify required parameter 'callTagId' is not null or undefined
        if (params.callTagId === null || params.callTagId === undefined) {
            throw new utils_1.RequiredError('callTagId', 'Required parameter callTagId was null or undefined when calling deleteCallTag.');
        }
        const path = `/calls/{callId}/tags/{callTagId}`
            .replace(`{${'callId'}}`, String(params.callId))
            .replace(`{${'callTagId'}}`, String(params.callTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tags for the provided call Id.
    * @summary Gets all call tags
    * @param {string} callId Call Identifier
    * @param {string} callTagId ID of the tag
    * @throws {RequiredError}
    */
    getCallTag(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling getCallTag.');
        }
        // verify required parameter 'callTagId' is not null or undefined
        if (params.callTagId === null || params.callTagId === undefined) {
            throw new utils_1.RequiredError('callTagId', 'Required parameter callTagId was null or undefined when calling getCallTag.');
        }
        const path = `/calls/{callId}/tags/{callTagId}`
            .replace(`{${'callId'}}`, String(params.callId))
            .replace(`{${'callTagId'}}`, String(params.callTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the tags for a call with the provided call Id.
    * @summary Get call tags
    * @param {string} callId Call Identifier
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @throws {RequiredError}
    */
    getCallTags(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling getCallTags.');
        }
        const path = `/calls/{callId}/tags`
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the tag for the provided call Id.
    * @summary Update a call tag
    * @param {string} callId Call Identifier
    * @param {string} callTagId ID of the tag
    * @param {CallTagPutRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateCallTag(params) {
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling updateCallTag.');
        }
        // verify required parameter 'callTagId' is not null or undefined
        if (params.callTagId === null || params.callTagId === undefined) {
            throw new utils_1.RequiredError('callTagId', 'Required parameter callTagId was null or undefined when calling updateCallTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCallTag.');
        }
        const path = `/calls/{callId}/tags/{callTagId}`
            .replace(`{${'callId'}}`, String(params.callId))
            .replace(`{${'callTagId'}}`, String(params.callTagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a conference by using the provided details in this request body.
    * @summary Create a Conference
    * @param {PostConferenceRequest} body
    * @throws {RequiredError}
    */
    createConference(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConference.');
        }
        const path = `/conferences`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete an conference
    * @summary Delete a conference
    * @param {string} conferenceId conferenceId
    * @throws {RequiredError}
    */
    deleteConference(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling deleteConference.');
        }
        const path = `/conferences/{conferenceId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the meta data for this conference. The result is limited by ownership of the conference.  Future extensions will include start/stop recordings.  TODO Conference will be created to use either the Mitel numbers or the customer dial in numbers.
    * @summary Get a conference
    * @param {string} conferenceId conferenceId
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getConference(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getConference.');
        }
        const path = `/conferences/{conferenceId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all conference calls for this account. Data is paged on the server and sorted by most recent conference first.  *Available Filter Operations*: [eq, ne, lt, gt, le, ge, and, or], e.g. $filter=accessCode eq '339323008' or $filter=name eq 'MyMeeting' , or &filter=externalConferenceId eq '2307d9a7-abc1-4f02-946a-ee8a2c3c143b' *Expandable subresources: tags.  *Special query string*: containsAllParticipants=participantId1,participantId2,me,...participantIdx
    * @summary Get Conferences
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Skiptoken] Continuation token from previous query for paging
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] Odata filter param
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getConferences(params) {
        const path = `/conferences`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Skiptoken !== undefined) {
            query['$skiptoken'] = params.$Skiptoken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve meeting attendance records for a particular user. Data is paged on the server and sorted by most recent meeting attendances.
    * @summary Get user meetings attendances
    * @param {string} userId User Identifier
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Skiptoken] Continuation token from previous query for paging
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] Odata filter param
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getUserAttendances(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserAttendances.');
        }
        const path = `/users/{userId}/attendances`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Skiptoken !== undefined) {
            query['$skiptoken'] = params.$Skiptoken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get conferences in the context of a user. This contains conferences the user created and being participant of. Data is paged on the server and sorted by most recent conference first.  *Available Filter Operations*: [eq, ne, lt, gt, le, ge, and, or], i.e. $filter=accessCode eq '339323008' *Expandable subresources: tags
    * @summary Gets conferences for a given user
    * @param {string} userId User Identifier
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Skiptoken] Continuation token from previous query for paging
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] Odata filter param
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getUserConferences(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserConferences.');
        }
        const path = `/users/{userId}/conferences`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skiptoken !== undefined) {
            query['$skiptoken'] = params.$Skiptoken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Perform an action on a conference
    * @summary Perform an action on a conference
    * @param {string} conferenceId conferenceId
    * @param {PostConferenceByIdRequest} body
    * @throws {RequiredError}
    */
    runConferenceControlCommand(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling runConferenceControlCommand.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling runConferenceControlCommand.');
        }
        const path = `/conferences/{conferenceId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the properties of this conference
    * @summary Update a conference
    * @param {string} conferenceId conferenceId
    * @param {UpdateConferenceRequest} body
    * @throws {RequiredError}
    */
    updateConference(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling updateConference.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateConference.');
        }
        const path = `/conferences/{conferenceId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a tag for the conference with the provided ID.
    * @summary Create a conference tag
    * @param {string} conferenceId ID of the conference
    * @param {ConferenceTagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    createConferenceTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling createConferenceTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConferenceTag.');
        }
        const path = `/conferences/{conferenceId}/tags`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the tag for the provided conference ID.
    * @summary Delete a tag
    * @param {string} conferenceId ID of the conference
    * @param {string} conferenceTagId ID of the conference tag
    * @throws {RequiredError}
    */
    deleteConferenceTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling deleteConferenceTag.');
        }
        // verify required parameter 'conferenceTagId' is not null or undefined
        if (params.conferenceTagId === null || params.conferenceTagId === undefined) {
            throw new utils_1.RequiredError('conferenceTagId', 'Required parameter conferenceTagId was null or undefined when calling deleteConferenceTag.');
        }
        const path = `/conferences/{conferenceId}/tags/{conferenceTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'conferenceTagId'}}`, String(params.conferenceTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tag for the provided conference ID.
    * @summary Gets a conference tag
    * @param {string} conferenceId ID of the conference
    * @param {string} conferenceTagId ID of the conference tag
    * @throws {RequiredError}
    */
    getConferenceTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getConferenceTag.');
        }
        // verify required parameter 'conferenceTagId' is not null or undefined
        if (params.conferenceTagId === null || params.conferenceTagId === undefined) {
            throw new utils_1.RequiredError('conferenceTagId', 'Required parameter conferenceTagId was null or undefined when calling getConferenceTag.');
        }
        const path = `/conferences/{conferenceId}/tags/{conferenceTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'conferenceTagId'}}`, String(params.conferenceTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the tags for a conference with the provided ID.
    * @summary Get conference tags
    * @param {string} conferenceId ID of the conference
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @throws {RequiredError}
    */
    getConferenceTags(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getConferenceTags.');
        }
        const path = `/conferences/{conferenceId}/tags`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the tag for the provided conference ID.
    * @summary Update a conference tag
    * @param {string} conferenceId ID of the conference
    * @param {string} conferenceTagId ID of the conference tag
    * @param {ConferenceTagPutRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateConferenceTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling updateConferenceTag.');
        }
        // verify required parameter 'conferenceTagId' is not null or undefined
        if (params.conferenceTagId === null || params.conferenceTagId === undefined) {
            throw new utils_1.RequiredError('conferenceTagId', 'Required parameter conferenceTagId was null or undefined when calling updateConferenceTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateConferenceTag.');
        }
        const path = `/conferences/{conferenceId}/tags/{conferenceTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'conferenceTagId'}}`, String(params.conferenceTagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create DID. It can be assigned to an entity, i.e to user, app, and group etc. through creation.
    * @summary Create DID
    * @param {CreateDidRequest} body
    * @throws {RequiredError}
    */
    createDid(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createDid.');
        }
        const path = `/dids`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete the DID from your account.
    * @summary Delete DID
    * @param {string} didNumber DID number Identifier, the value is the DID. It is in E.164 format
    * @throws {RequiredError}
    */
    deleteDid(params) {
        // verify required parameter 'didNumber' is not null or undefined
        if (params.didNumber === null || params.didNumber === undefined) {
            throw new utils_1.RequiredError('didNumber', 'Required parameter didNumber was null or undefined when calling deleteDid.');
        }
        const path = `/dids/{didNumber}`
            .replace(`{${'didNumber'}}`, String(params.didNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the DID from your account.
    * @summary Get DID
    * @param {string} didNumber DID number Identifier, the value is the DID. It is in E.164 format
    * @throws {RequiredError}
    */
    getDid(params) {
        // verify required parameter 'didNumber' is not null or undefined
        if (params.didNumber === null || params.didNumber === undefined) {
            throw new utils_1.RequiredError('didNumber', 'Required parameter didNumber was null or undefined when calling getDid.');
        }
        const path = `/dids/{didNumber}`
            .replace(`{${'didNumber'}}`, String(params.didNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all DIDs from your account.
    * @summary Get DIDs
    * @throws {RequiredError}
    */
    getDids(params) {
        const path = `/dids`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the DID for the provided did number.
    * @summary Update DID
    * @param {string} didNumber DID number Identifier, the value is the DID. It is in E.164 format
    * @param {UpdateDidRequest} body
    * @throws {RequiredError}
    */
    updateDid(params) {
        // verify required parameter 'didNumber' is not null or undefined
        if (params.didNumber === null || params.didNumber === undefined) {
            throw new utils_1.RequiredError('didNumber', 'Required parameter didNumber was null or undefined when calling updateDid.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateDid.');
        }
        const path = `/dids/{didNumber}`
            .replace(`{${'didNumber'}}`, String(params.didNumber));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Make a call from an endpoint to a destination.
    * @summary Make a Call
    * @param {string} endpointId Device Identifier
    * @param {CreateCallRequest} body
    * @throws {RequiredError}
    */
    createEndpointCall(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling createEndpointCall.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createEndpointCall.');
        }
        const path = `/endpoints/{endpointId}/calls`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used for deleting the forwarding details of the endpoint.
    * @summary Delete Call Forwarding Details
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    deleteEndpointForwardingOptions(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling deleteEndpointForwardingOptions.');
        }
        const path = `/endpoints/{endpointId}/forwardings`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Removes the pstnRouting number for the provided endpoint ID.
    * @summary Delete pstnRouting
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    deletePstnRoutingNumber(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling deletePstnRoutingNumber.');
        }
        const path = `/endpoints/{endpointId}/pstn-routing`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the current state of the endpoint for the provided ID. Sometimes referred to as line state.
    * @summary Get an Endpoint State
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    getEndpoint(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpoint.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the snapshot of the call with provided call ID, associated with the endpoint of the provided endpoint ID.
    * @summary Get an Active Call State
    * @param {string} endpointId Device Identifier
    * @param {string} callId Call Identifier
    * @throws {RequiredError}
    */
    getEndpointCall(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointCall.');
        }
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling getEndpointCall.');
        }
        const path = `/endpoints/{endpointId}/calls/{callId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a list of active calls currently associated to the endpoint for the provided ID.
    * @summary List Active Calls
    * @param {string} endpointId Device Identifier
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getEndpointCalls(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointCalls.');
        }
        const path = `/endpoints/{endpointId}/calls`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the forwarding details of an endpoint.
    * @summary Get Call Forwarding Details
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    getEndpointForwardingOptions(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getEndpointForwardingOptions.');
        }
        const path = `/endpoints/{endpointId}/forwardings`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * returns true if endpoint is pstn routing, false if it is not.
    * @summary Gets PSTN Routing Details
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    getPstnRoutingOptions(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling getPstnRoutingOptions.');
        }
        const path = `/endpoints/{endpointId}/pstn-routing`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Change the state of the call by issuing an appropriate action to take on the call, for the provided call ID associated with a provided endpoint ID. Some actions require additional arguments.  Examples  To toggle the holding state of the call  `{ \"action\": \"hold\"}`  To make a blind transfer  `{ \"action\": \"blindTransfer\", \"destination\": \"5555\"}`  To conference a consultation call with the call on hold  `{ \"action\": \"conference\" }`  To make a supervised transfer  `{ \"action\": \"supervisedTransfer\", \"callId\": \"5555555555\"} (coming soon)`  To consult call  `{ \"action\": \"consult\", \"destination\": \"5555\"}`  To pause a recording  `{ \"action\": \"pauseRecording\" }`  To resume a paused recording  `{ \"action\": \"resumeRecording\" }`  To tag the recording  `{ \"action\": \"tagRecording\", \"args\": \"{ \\\"CustomP100\\\": \\\"Queue Name\\\", \\\"CustomP101\\\": \\\"Queue Disable\\\" }\" }`    For additional actions and arguments see object model definition.
    * @summary Change an Active Call State
    * @param {string} endpointId Device Identifier
    * @param {string} callId Call Identifier
    * @param {UpdateEndpointCallRequest} body
    * @throws {RequiredError}
    */
    updateCallByEndpointId(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateCallByEndpointId.');
        }
        // verify required parameter 'callId' is not null or undefined
        if (params.callId === null || params.callId === undefined) {
            throw new utils_1.RequiredError('callId', 'Required parameter callId was null or undefined when calling updateCallByEndpointId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateCallByEndpointId.');
        }
        const path = `/endpoints/{endpointId}/calls/{callId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId))
            .replace(`{${'callId'}}`, String(params.callId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used for changing the state of the endpoint such as set do not disturb or turn on message waiting indicator for desktop phones.
    * @summary Change an Endpoint State
    * @param {string} endpointId Device Identifier
    * @param {UpdateEndpointRequest} body
    * @throws {RequiredError}
    */
    updateEndpoint(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateEndpoint.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateEndpoint.');
        }
        const path = `/endpoints/{endpointId}`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used for updating the forwarding details of the endpoint.
    * @summary Update Call Forwarding Details
    * @param {string} endpointId Device Identifier
    * @param {UpdateEndpointForwardingRequest} body
    * @throws {RequiredError}
    */
    updateEndpointForwardingOptions(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updateEndpointForwardingOptions.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateEndpointForwardingOptions.');
        }
        const path = `/endpoints/{endpointId}/forwardings`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used for updating the pstn routing details of the endpoint.
    * @summary Update PSTN Routing Details
    * @param {string} endpointId Device Identifier
    * @throws {RequiredError}
    */
    updatePstnRoutingNumber(params) {
        // verify required parameter 'endpointId' is not null or undefined
        if (params.endpointId === null || params.endpointId === undefined) {
            throw new utils_1.RequiredError('endpointId', 'Required parameter endpointId was null or undefined when calling updatePstnRoutingNumber.');
        }
        const path = `/endpoints/{endpointId}/pstn-routing`
            .replace(`{${'endpointId'}}`, String(params.endpointId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates extension. It can be assigned to an entity, i.e to user, app, and group etc. through creation.
    * @summary Create Extension
    * @param {CreateExtensionRequest} body
    * @throws {RequiredError}
    */
    createExtension(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createExtension.');
        }
        const path = `/extensions`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete the extension for the provided extension number from your account.
    * @summary Delete an Extension
    * @param {string} extensionNumber Extension number Identifier, the value is the extension. It is a dialable number including * and #
    * @throws {RequiredError}
    */
    deleteExtension(params) {
        // verify required parameter 'extensionNumber' is not null or undefined
        if (params.extensionNumber === null || params.extensionNumber === undefined) {
            throw new utils_1.RequiredError('extensionNumber', 'Required parameter extensionNumber was null or undefined when calling deleteExtension.');
        }
        const path = `/extensions/{extensionNumber}`
            .replace(`{${'extensionNumber'}}`, String(params.extensionNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the extension for the provided extension number in your account.
    * @summary Get Extension
    * @param {string} extensionNumber Extension number Identifier, the value is the extension. It is a dialable number including * and #
    * @throws {RequiredError}
    */
    getExtension(params) {
        // verify required parameter 'extensionNumber' is not null or undefined
        if (params.extensionNumber === null || params.extensionNumber === undefined) {
            throw new utils_1.RequiredError('extensionNumber', 'Required parameter extensionNumber was null or undefined when calling getExtension.');
        }
        const path = `/extensions/{extensionNumber}`
            .replace(`{${'extensionNumber'}}`, String(params.extensionNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets all extensions from your account.   When ?$orderby=extensionNumber desc&$top=1, it return the last extension that has been assigned in your account.
    * @summary Get Extensions
    * @param {string} [$Orderby] Odata orderby param. Uses the format &#x60;$orderby&#x3D;extensionNumber (asc|desc)&#x60;. If neither &#x60;asc&#x60; nor &#x60;desc&#x60; is defined, &#x60;asc is used.
    * @param {number} [$Top] Get number of extensions
    * @throws {RequiredError}
    */
    getExtensions(params) {
        const path = `/extensions`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the extension for the provided extension number.
    * @summary Update Extension
    * @param {string} extensionNumber Extension number Identifier, the value is the extension. It is a dialable number including * and #
    * @param {UpdateExtensionRequest} body
    * @throws {RequiredError}
    */
    updateExtension(params) {
        // verify required parameter 'extensionNumber' is not null or undefined
        if (params.extensionNumber === null || params.extensionNumber === undefined) {
            throw new utils_1.RequiredError('extensionNumber', 'Required parameter extensionNumber was null or undefined when calling updateExtension.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateExtension.');
        }
        const path = `/extensions/{extensionNumber}`
            .replace(`{${'extensionNumber'}}`, String(params.extensionNumber));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add a gateway-link to a site
    * @summary New gateway-link
    * @param {string} siteId Site Identifier
    * @param {GatewayLinkPostRequest} body
    * @throws {RequiredError}
    */
    createGatewayLink(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createGatewayLink.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGatewayLink.');
        }
        const path = `/sites/{siteId}/gateway-links`
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add a gateway-link to a site
    * @summary New gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {GatewayLinkPostRequest} body
    * @throws {RequiredError}
    */
    createGatewayLinkByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling createGatewayLinkByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling createGatewayLinkByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createGatewayLinkByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Remove gateway-link instance
    * @summary Delete gateway-link
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    deleteGatewayLink(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deleteGatewayLink.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling deleteGatewayLink.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Remove gateway-link instance
    * @summary Delete gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    deleteGatewayLinkByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteGatewayLinkByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling deleteGatewayLinkByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling deleteGatewayLinkByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return the gateway-link for the passed id
    * @summary Gets the gateway-link.
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getGatewayLink(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getGatewayLink.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getGatewayLink.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return the gateway-link for the passed id
    * @summary Gets the gateway-link.
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getGatewayLinkByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGatewayLinkByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getGatewayLinkByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getGatewayLinkByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return all the gateway-links for a site
    * @summary Gets the gateway-links for a site.
    * @param {string} siteId Site Identifier
    * @throws {RequiredError}
    */
    getGatewayLinks(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getGatewayLinks.');
        }
        const path = `/sites/{siteId}/gateway-links`
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return all the gateway-links for a site
    * @summary Gets the gateway-links for a site.
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @throws {RequiredError}
    */
    getGatewayLinksByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getGatewayLinksByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getGatewayLinksByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a gateway-link
    * @summary Update gateway-link
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {GatewayLinkPutRequest} body
    * @throws {RequiredError}
    */
    updateGatewayLink(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateGatewayLink.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updateGatewayLink.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGatewayLink.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a gateway-link
    * @summary Update gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {GatewayLinkPutRequest} body
    * @throws {RequiredError}
    */
    updateGatewayLinkByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateGatewayLinkByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateGatewayLinkByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updateGatewayLinkByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGatewayLinkByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Remove hold music for account
    * @summary Delete hold music file
    * @param {string} accountId Account Identifier
    * @param {string} musicId Music Identifier. This ID should be the file name, e.g music.wav
    * @throws {RequiredError}
    */
    deleteHoldMusic(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling deleteHoldMusic.');
        }
        // verify required parameter 'musicId' is not null or undefined
        if (params.musicId === null || params.musicId === undefined) {
            throw new utils_1.RequiredError('musicId', 'Required parameter musicId was null or undefined when calling deleteHoldMusic.');
        }
        const path = `/accounts/{accountId}/musics/{musicId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'musicId'}}`, String(params.musicId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get a list of hold music for the account and the current chosen music to play when call is on hold
    * @summary Get hold music list
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @throws {RequiredError}
    */
    getHoldMusicList(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getHoldMusicList.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getHoldMusicList.');
        }
        const path = `/settings/accounts/{accountId}/sites/{siteId}/musics`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Upload hold music for account. POST new hold music files if not exist or UPDATE files if exist
    * @summary Update hold music file
    * @param {string} accountId Account Identifier
    * @param {string} musicId Music Identifier. This ID should be the file name, e.g music.wav
    * @param {PutHoldMusicRequest} body
    * @throws {RequiredError}
    */
    putHoldMusic(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling putHoldMusic.');
        }
        // verify required parameter 'musicId' is not null or undefined
        if (params.musicId === null || params.musicId === undefined) {
            throw new utils_1.RequiredError('musicId', 'Required parameter musicId was null or undefined when calling putHoldMusic.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling putHoldMusic.');
        }
        const path = `/accounts/{accountId}/musics/{musicId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'musicId'}}`, String(params.musicId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Choose the hold music to play during the call. This will update the hold music list for account
    * @summary Update hold music list
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {PutHoldMusicListRequest} body
    * @throws {RequiredError}
    */
    putHoldMusicList(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling putHoldMusicList.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling putHoldMusicList.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling putHoldMusicList.');
        }
        const path = `/settings/accounts/{accountId}/sites/{siteId}/musics`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Convert an mp3 file to mulaw or alaw
    * @summary Transcode mp3 file
    * @param {MediaTranscodeRequest} body
    * @throws {RequiredError}
    */
    transcodeMedia(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling transcodeMedia.');
        }
        const path = `/media-transcode`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Add a participant into the conference with the provided ID.
    * @summary Add a Participant
    * @param {string} conferenceId Conference ID
    * @param {PostConferenceParticipantRequest} body
    * @throws {RequiredError}
    */
    createParticipant(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling createParticipant.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createParticipant.');
        }
        const path = `/conferences/{conferenceId}/participants`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Used to get a client side token and URL for connecting to the conference.
    * @summary Creates connection details for this participant
    * @param {string} conferenceId Conference identifier
    * @param {string} participantId Participant identifer
    * @throws {RequiredError}
    */
    createParticipantConnection(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling createParticipantConnection.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling createParticipantConnection.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/connections`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Remove participant form this conference.
    * @summary Remove a Participant
    * @param {string} conferenceId Conference Identifier
    * @param {string} participantId Pariticipant Identifier
    * @throws {RequiredError}
    */
    deleteParticipant(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling deleteParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling deleteParticipant.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the participant for the provided ID.
    * @summary Get a Participant
    * @param {string} conferenceId Conference Identifier
    * @param {string} participantId Participant Identifier
    * @throws {RequiredError}
    */
    getParticipant(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling getParticipant.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the participants for a conference with the provided ID.
    * @summary Get Participants of a Conference
    * @param {string} conferenceId Conference ID
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$Skiptoken] Continuation token from previous query for paging
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getParticipants(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getParticipants.');
        }
        const path = `/conferences/{conferenceId}/participants`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Skiptoken !== undefined) {
            query['$skiptoken'] = params.$Skiptoken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the properties of this participant for given conference
    * @summary Update a conference participant
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {UpdateConferenceParticipantRequest} body
    * @throws {RequiredError}
    */
    updateConferenceParticipant(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling updateConferenceParticipant.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling updateConferenceParticipant.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateConferenceParticipant.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a tag for a participant with the provided ID for the conference with the provided ID.
    * @summary Create a conference participant tag
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {ParticipantTagPostRequest} body Tag POST request object
    * @throws {RequiredError}
    */
    createConferenceParticipantTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling createConferenceParticipantTag.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling createConferenceParticipantTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createConferenceParticipantTag.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/tags`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the tag with the provided ID for a participant with the provided ID for the conference with the provided ID.
    * @summary Delete a conference participant tag
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {string} participantTagId ID of the participant tag for a conference
    * @throws {RequiredError}
    */
    deleteConferenceParticipantTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling deleteConferenceParticipantTag.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling deleteConferenceParticipantTag.');
        }
        // verify required parameter 'participantTagId' is not null or undefined
        if (params.participantTagId === null || params.participantTagId === undefined) {
            throw new utils_1.RequiredError('participantTagId', 'Required parameter participantTagId was null or undefined when calling deleteConferenceParticipantTag.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/tags/{participantTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId))
            .replace(`{${'participantTagId'}}`, String(params.participantTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the tag with the provided ID for a participant with the provided ID for the conference with the provided ID.
    * @summary Gets a conference participant tag
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {string} participantTagId ID of the participant tag for a conference
    * @throws {RequiredError}
    */
    getConferenceParticipantTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getConferenceParticipantTag.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling getConferenceParticipantTag.');
        }
        // verify required parameter 'participantTagId' is not null or undefined
        if (params.participantTagId === null || params.participantTagId === undefined) {
            throw new utils_1.RequiredError('participantTagId', 'Required parameter participantTagId was null or undefined when calling getConferenceParticipantTag.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/tags/{participantTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId))
            .replace(`{${'participantTagId'}}`, String(params.participantTagId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the tags of a participant with the provided ID for a conference with the provided ID.
    * @summary Get conference Participant tags
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @throws {RequiredError}
    */
    getConferenceParticipantTags(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling getConferenceParticipantTags.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling getConferenceParticipantTags.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/tags`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the tag with the provided ID for a participant with the provided ID for the conference with the provided ID.
    * @summary Update a conference participant tag
    * @param {string} conferenceId ID of the conference
    * @param {string} participantId ID of the participant
    * @param {string} participantTagId ID of the participant tag for a conference
    * @param {ParticipantTagPutRequest} body Tag PUT request object
    * @throws {RequiredError}
    */
    updateConferenceParticipantTag(params) {
        // verify required parameter 'conferenceId' is not null or undefined
        if (params.conferenceId === null || params.conferenceId === undefined) {
            throw new utils_1.RequiredError('conferenceId', 'Required parameter conferenceId was null or undefined when calling updateConferenceParticipantTag.');
        }
        // verify required parameter 'participantId' is not null or undefined
        if (params.participantId === null || params.participantId === undefined) {
            throw new utils_1.RequiredError('participantId', 'Required parameter participantId was null or undefined when calling updateConferenceParticipantTag.');
        }
        // verify required parameter 'participantTagId' is not null or undefined
        if (params.participantTagId === null || params.participantTagId === undefined) {
            throw new utils_1.RequiredError('participantTagId', 'Required parameter participantTagId was null or undefined when calling updateConferenceParticipantTag.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateConferenceParticipantTag.');
        }
        const path = `/conferences/{conferenceId}/participants/{participantId}/tags/{participantTagId}`
            .replace(`{${'conferenceId'}}`, String(params.conferenceId))
            .replace(`{${'participantId'}}`, String(params.participantId))
            .replace(`{${'participantTagId'}}`, String(params.participantTagId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return the pbx-capabilities for gateway-link.
    * @summary Gets the pbx-capabilities for a gateway-link.
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getPbxCapabilities(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxCapabilities.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getPbxCapabilities.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}/pbx-capabilities`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return the pbx-capabilities for gateway-link.
    * @summary Gets the pbx-capabilities for a gateway-link.
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getPbxCapabilitiesByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getPbxCapabilitiesByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getPbxCapabilitiesByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getPbxCapabilitiesByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}/pbx-capabilities`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update pbx-capabilities for gateway-link
    * @summary Update pbx-capabilities for gateway-link
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {PbxCapabilitiesPutRequest} body
    * @throws {RequiredError}
    */
    updatePbxCapabilities(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updatePbxCapabilities.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updatePbxCapabilities.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePbxCapabilities.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}/pbx-capabilities`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update pbx-capabilities for gateway-link
    * @summary Update pbx-capabilities for gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {PbxCapabilitiesPutRequest} body
    * @throws {RequiredError}
    */
    updatePbxCapabilitiesByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updatePbxCapabilitiesByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updatePbxCapabilitiesByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updatePbxCapabilitiesByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePbxCapabilitiesByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}/pbx-capabilities`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates meta data for the prompt.  Prompt meta must be created before the media can be uploaded.
    * @summary Creates a prompt
    * @param {PostPromptRequest} body
    * @throws {RequiredError}
    */
    createPrompt(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPrompt.');
        }
        const path = `/prompts`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Removes the prompt from the system.
    * @summary Delete prompt from the system
    * @param {string} promptId ID of the prompt
    * @throws {RequiredError}
    */
    deletePrompt(params) {
        // verify required parameter 'promptId' is not null or undefined
        if (params.promptId === null || params.promptId === undefined) {
            throw new utils_1.RequiredError('promptId', 'Required parameter promptId was null or undefined when calling deletePrompt.');
        }
        const path = `/prompts/{promptId}`
            .replace(`{${'promptId'}}`, String(params.promptId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves prompt media.
    * @summary Get prompt media
    * @param {string} promptId ID of the prompt
    * @throws {RequiredError}
    */
    getPrompt(params) {
        // verify required parameter 'promptId' is not null or undefined
        if (params.promptId === null || params.promptId === undefined) {
            throw new utils_1.RequiredError('promptId', 'Required parameter promptId was null or undefined when calling getPrompt.');
        }
        const path = `/prompts/{promptId}`
            .replace(`{${'promptId'}}`, String(params.promptId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves meta data about the prompt.
    * @summary Get prompt metadata
    * @param {string} promptId ID of the prompt
    * @throws {RequiredError}
    */
    getPromptMeta(params) {
        // verify required parameter 'promptId' is not null or undefined
        if (params.promptId === null || params.promptId === undefined) {
            throw new utils_1.RequiredError('promptId', 'Required parameter promptId was null or undefined when calling getPromptMeta.');
        }
        const path = `/prompts/{promptId}/meta`
            .replace(`{${'promptId'}}`, String(params.promptId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves prompts from the system.  Prompts that you don't have permission to view will not be returned.
    * @summary Get prompts
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] Odata filter param
    * @throws {RequiredError}
    */
    getPrompts(params) {
        const path = `/prompts`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update prompt media.  Returns an error if the prompt meta hasn't been created.
    * @summary Update prompt media
    * @param {string} promptId ID of the prompt
    * @param {string} body Binary data of the prompt
    * @throws {RequiredError}
    */
    updatePrompt(params) {
        // verify required parameter 'promptId' is not null or undefined
        if (params.promptId === null || params.promptId === undefined) {
            throw new utils_1.RequiredError('promptId', 'Required parameter promptId was null or undefined when calling updatePrompt.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePrompt.');
        }
        const path = `/prompts/{promptId}`
            .replace(`{${'promptId'}}`, String(params.promptId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Removes the recording from the system.  This operation requires priviledged access.
    * @summary Delete recording from the system
    * @param {string} recordingId ID of the recording
    * @throws {RequiredError}
    */
    deleteRecording(params) {
        // verify required parameter 'recordingId' is not null or undefined
        if (params.recordingId === null || params.recordingId === undefined) {
            throw new utils_1.RequiredError('recordingId', 'Required parameter recordingId was null or undefined when calling deleteRecording.');
        }
        const path = `/recordings/{recordingId}`
            .replace(`{${'recordingId'}}`, String(params.recordingId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * By default, this returns just the meta data of the recording. To get the media file, specify $expand=media. A time limited URL is returned in the _embedded portion that can be used to retrieve the media file.
    * @summary Get the recording meta data and optionally the media file
    * @param {string} recordingId ID of the recording
    * @param {string} [mediaFormat] Format of the file in the embedded media link.
    * @throws {RequiredError}
    */
    getRecording(params) {
        // verify required parameter 'recordingId' is not null or undefined
        if (params.recordingId === null || params.recordingId === undefined) {
            throw new utils_1.RequiredError('recordingId', 'Required parameter recordingId was null or undefined when calling getRecording.');
        }
        const path = `/recordings/{recordingId}`
            .replace(`{${'recordingId'}}`, String(params.recordingId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.mediaFormat !== undefined) {
            query['media-format'] = params.mediaFormat;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get all the recordings in the account. Recordings that you don't have permission to view will not be returned. Only meta data of the recordings are returned. If you want the actual media file, use GET /recordings/<id>. A filter on callId can be specified. Example: $filter = callId eq 'some callId/conference Id'
    * @summary Get all the recordings in the account
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Orderby] Odata filter param
    * @throws {RequiredError}
    */
    getRecordings(params) {
        const path = `/recordings`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Orderby !== undefined) {
            query['$orderby'] = params.$Orderby;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the meta data of a recording
    * @summary Update a recording's metadata
    * @param {string} recordingId ID of the recording
    * @param {UpdateRecordingRequest} body
    * @throws {RequiredError}
    */
    updateRecording(params) {
        // verify required parameter 'recordingId' is not null or undefined
        if (params.recordingId === null || params.recordingId === undefined) {
            throw new utils_1.RequiredError('recordingId', 'Required parameter recordingId was null or undefined when calling updateRecording.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateRecording.');
        }
        const path = `/recordings/{recordingId}`
            .replace(`{${'recordingId'}}`, String(params.recordingId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Return the media services metadata
    * @summary Get Media Service metadata
    * @throws {RequiredError}
    */
    getServiceInfo(params) {
        const path = `/service-info`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves emergency numbers.
    * @summary Get emergency numbers
    * @throws {RequiredError}
    */
    getEmergencyNumbers(params) {
        const path = `/emergency-numbers`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves properties of a site if the token has role of `ACCOUNT_ADMIN` or 'GLOBAL_ADMIN'.
    * @summary Get a site
    * @param {string} siteId Site Identifier
    * @throws {RequiredError}
    */
    getSite(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getSite.');
        }
        const path = `/sites/{siteId}`
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves properties of a site if the token has role of `ACCOUNT_ADMIN` or 'GLOBAL_ADMIN'.
    * @summary Get a site
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @throws {RequiredError}
    */
    getSiteByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getSiteByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getSiteByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update properties of a site if the token has role of`ACCOUNT_ADMIN` or 'GLOBAL_ADMIN'.
    * @summary Update a site
    * @param {string} siteId Site Identifier
    * @param {SitePutRequest} body
    * @throws {RequiredError}
    */
    updateSite(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateSite.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSite.');
        }
        const path = `/sites/{siteId}`
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update properties of a site if the token has role of`ACCOUNT_ADMIN` or 'GLOBAL_ADMIN'.
    * @summary Update a site
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {SitePutRequest} body
    * @throws {RequiredError}
    */
    updateSiteByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateSiteByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateSiteByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSiteByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve the specification in swagger format for this API.
    * @summary Get Spec
    * @throws {RequiredError}
    */
    getSpecification(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieves the status of key components in the microservice if the token has role of `ACCOUNT_ADMIN` or 'GLOBAL_ADMIN'.
    * @summary Get status of microservice
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user with userId (email, userId or mobile number)
    * @summary Get a User
    * @param {string} userId User Identifier
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getUser(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUser.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve user with userId (email, userId or mobile number)
    * @summary Get a User
    * @param {string} accountId Account Identifier
    * @param {string} userId User Identifier
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Retrieve all users.  `GLOBAL_ADMIN` will get users in all accounts. `PARTNER_ADMIN` will get users in all accounts within partner. `ACCOUNT_ADMIN` and `USER` will get all users within account. Not supported for `GUEST`.  Data is paged on the server and sorted by most recent partner first.
    * @summary Get Users
    * @param {string} accountId Account Identifier
    * @param {number} [$Skip] Number of items to skip
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Skiptoken] Continuation token from previous query for paging
    * @param {string} [$Filter] Odata filter param
    * @param {string} [$Expand] Odata expand param
    * @throws {RequiredError}
    */
    getUsersByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getUsersByAccountId.');
        }
        const path = `/accounts/{accountId}/users`
            .replace(`{${'accountId'}}`, String(params.accountId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Skiptoken !== undefined) {
            query['$skiptoken'] = params.$Skiptoken;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.$Expand !== undefined) {
            query['$expand'] = params.$Expand;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a User.
    * @summary Update a user to assign it to gateway-link.
    * @param {string} userId User Identifier
    * @param {UserPutRequest} body
    * @throws {RequiredError}
    */
    updateUser(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUser.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUser.');
        }
        const path = `/users/{userId}`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update a User.
    * @summary Update a user to assign it to gateway-link.
    * @param {string} accountId Account Identifier
    * @param {string} userId User Identifier
    * @param {UserPutRequest} body
    * @throws {RequiredError}
    */
    updateUserByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateUserByAccountId.');
        }
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUserByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateUserByAccountId.');
        }
        const path = `/accounts/{accountId}/users/{userId}`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the voicemail information associated with a gateway-link.
    * @summary Get the voicemail information for a gateway-link.
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getVoicemailInfo(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getVoicemailInfo.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getVoicemailInfo.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}/voicemails`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get the voicemail information associated with a gateway-link
    * @summary Get the voicemail information for a gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @throws {RequiredError}
    */
    getVoicemailInfoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling getVoicemailInfoByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling getVoicemailInfoByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling getVoicemailInfoByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}/voicemails`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update the voicemail information associated with a gateway-link
    * @summary Update the voicemail information for a gateway-link
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {VoicemailInfoPutRequest} body
    * @throws {RequiredError}
    */
    updateVoicemailInfo(params) {
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateVoicemailInfo.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updateVoicemailInfo.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateVoicemailInfo.');
        }
        const path = `/sites/{siteId}/gateway-links/{gatewayLinkId}/voicemails`
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Update voicemail information for gateway-link
    * @summary Update voicemail information for gateway-link
    * @param {string} accountId Account Identifier
    * @param {string} siteId Site Identifier
    * @param {string} gatewayLinkId A unique identifier that is used in the Media microservice to identify a particular gateway-link
    * @param {VoicemailInfoPutRequest} body
    * @throws {RequiredError}
    */
    updateVoicemailInfoByAccountId(params) {
        // verify required parameter 'accountId' is not null or undefined
        if (params.accountId === null || params.accountId === undefined) {
            throw new utils_1.RequiredError('accountId', 'Required parameter accountId was null or undefined when calling updateVoicemailInfoByAccountId.');
        }
        // verify required parameter 'siteId' is not null or undefined
        if (params.siteId === null || params.siteId === undefined) {
            throw new utils_1.RequiredError('siteId', 'Required parameter siteId was null or undefined when calling updateVoicemailInfoByAccountId.');
        }
        // verify required parameter 'gatewayLinkId' is not null or undefined
        if (params.gatewayLinkId === null || params.gatewayLinkId === undefined) {
            throw new utils_1.RequiredError('gatewayLinkId', 'Required parameter gatewayLinkId was null or undefined when calling updateVoicemailInfoByAccountId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateVoicemailInfoByAccountId.');
        }
        const path = `/accounts/{accountId}/sites/{siteId}/gateway-links/{gatewayLinkId}/voicemails`
            .replace(`{${'accountId'}}`, String(params.accountId))
            .replace(`{${'siteId'}}`, String(params.siteId))
            .replace(`{${'gatewayLinkId'}}`, String(params.gatewayLinkId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a voicemail box for the principal in the token
    * @summary Create voicemail box
    * @param {CreateVoicemailBoxRequest} body
    * @throws {RequiredError}
    */
    createVoicemailBox(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createVoicemailBox.');
        }
        const path = `/voicemailboxes`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Create a voicemail box for a user.
    * @summary Create user voicemail box
    * @param {string} userId User Identifier
    * @param {CreateVoicemailBoxRequest} body
    * @throws {RequiredError}
    */
    createVoicemailBoxByUserId(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling createVoicemailBoxByUserId.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createVoicemailBoxByUserId.');
        }
        const path = `/users/{userId}/voicemailboxes`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a voicemail box for the principal in the token.
    * @summary Delete voicemail box
    * @param {string} voicemailNumber voicemail number
    * @throws {RequiredError}
    */
    deleteVoicemailBox(params) {
        // verify required parameter 'voicemailNumber' is not null or undefined
        if (params.voicemailNumber === null || params.voicemailNumber === undefined) {
            throw new utils_1.RequiredError('voicemailNumber', 'Required parameter voicemailNumber was null or undefined when calling deleteVoicemailBox.');
        }
        const path = `/voicemailboxes/{voicemailNumber}`
            .replace(`{${'voicemailNumber'}}`, String(params.voicemailNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Delete a voicemail box of a user.
    * @summary Delete user voicemail box
    * @param {string} userId User Identifier
    * @param {string} voicemailNumber voicemail number
    * @throws {RequiredError}
    */
    deleteVoicemailBoxByUserId(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling deleteVoicemailBoxByUserId.');
        }
        // verify required parameter 'voicemailNumber' is not null or undefined
        if (params.voicemailNumber === null || params.voicemailNumber === undefined) {
            throw new utils_1.RequiredError('voicemailNumber', 'Required parameter voicemailNumber was null or undefined when calling deleteVoicemailBoxByUserId.');
        }
        const path = `/users/{userId}/voicemailboxes/{voicemailNumber}`
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'voicemailNumber'}}`, String(params.voicemailNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get details of a voicemail box of a user.
    * @summary Get user voicemail box
    * @param {string} userId User Identifier
    * @param {string} voicemailNumber voicemail number
    * @throws {RequiredError}
    */
    getUserVoicemailBox(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserVoicemailBox.');
        }
        // verify required parameter 'voicemailNumber' is not null or undefined
        if (params.voicemailNumber === null || params.voicemailNumber === undefined) {
            throw new utils_1.RequiredError('voicemailNumber', 'Required parameter voicemailNumber was null or undefined when calling getUserVoicemailBox.');
        }
        const path = `/users/{userId}/voicemailboxes/{voicemailNumber}`
            .replace(`{${'userId'}}`, String(params.userId))
            .replace(`{${'voicemailNumber'}}`, String(params.voicemailNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get voicemail boxes of a user
    * @summary Get user voicemail boxes
    * @param {string} userId User Identifier
    * @throws {RequiredError}
    */
    getUserVoicemailBoxes(params) {
        // verify required parameter 'userId' is not null or undefined
        if (params.userId === null || params.userId === undefined) {
            throw new utils_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserVoicemailBoxes.');
        }
        const path = `/users/{userId}/voicemailboxes`
            .replace(`{${'userId'}}`, String(params.userId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get details of a voicemail box for the principal in the token.
    * @summary Get voicemail box
    * @param {string} voicemailNumber voicemail number
    * @throws {RequiredError}
    */
    getVoicemailBox(params) {
        // verify required parameter 'voicemailNumber' is not null or undefined
        if (params.voicemailNumber === null || params.voicemailNumber === undefined) {
            throw new utils_1.RequiredError('voicemailNumber', 'Required parameter voicemailNumber was null or undefined when calling getVoicemailBox.');
        }
        const path = `/voicemailboxes/{voicemailNumber}`
            .replace(`{${'voicemailNumber'}}`, String(params.voicemailNumber));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Get voicemail boxes for the principal in the token.
    * @summary Get voicemail boxes
    * @throws {RequiredError}
    */
    getVoicemailBoxes(params) {
        const path = `/voicemailboxes`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.MediaService = MediaService;
